export const THUMB_LOADING = "THUMB_LOADING";
export const ADD_THUMB = "ADD_THUMB";
export const THUMB_FAILED = "THUMB_FAILED";